var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 41,
    viewBox: "0 0 43 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.67,
    height: 40.67,
    rx: 8,
    fill: "#EBF2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.154 18.068H12.5617C11.8879 18.0628 11.2394 18.3076 10.759 18.7486C10.2786 19.1896 10.0056 19.7906 10 20.4194V29.3189C10.0125 30.6279 11.1591 31.6799 12.5617 31.6689H17.154C17.8277 31.6741 18.4763 31.4293 18.9567 30.9884C19.4371 30.5474 19.7101 29.9464 19.7156 29.3174V20.4194C19.7101 19.7906 19.4371 19.1896 18.9567 18.7486C18.4763 18.3076 17.8277 18.0628 17.154 18.068Z",
    stroke: "#0069CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.154 9.00091H12.5617C11.1873 8.96534 10.0414 9.97462 10 11.2572V12.7895C10.0414 14.0721 11.1873 15.0813 12.5617 15.0458H17.154C18.5282 15.0813 19.6742 14.0721 19.7156 12.7895V11.2572C19.6742 9.97462 18.5282 8.96534 17.154 9.00091Z",
    stroke: "#0069CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.516 22.602H30.1067C30.7808 22.6076 31.4296 22.363 31.9104 21.922C32.3912 21.4809 32.6645 20.8797 32.67 20.2506V11.3525C32.6645 10.7237 32.3915 10.1226 31.911 9.68163C31.4306 9.24065 30.7821 8.99583 30.1083 9.00106H25.516C24.8423 8.99583 24.1937 9.24065 23.7133 9.68163C23.2329 10.1226 22.9599 10.7237 22.9544 11.3525V20.2506C22.9599 20.8794 23.2329 21.4804 23.7133 21.9214C24.1937 22.3623 24.8423 22.6072 25.516 22.602Z",
    stroke: "#0069CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.516 31.6688H30.1067C31.4816 31.7052 32.6285 30.6957 32.67 29.4126V27.8802C32.6285 26.5976 31.4826 25.5884 30.1083 25.624H25.516C24.1418 25.5884 22.9958 26.5976 22.9543 27.8802V29.4111C22.9948 30.6942 24.1411 31.7043 25.516 31.6688Z",
    stroke: "#0069CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardImage);
export default __webpack_public_path__ + "static/media/Dashboard-Image.770d44a7d79ef1e93aaa7223d2a618c0.svg";
export { ForwardRef as ReactComponent };